import { API_BASE_URL } from 'config';

const API_URL = API_BASE_URL;

export const fetchWallet = async (token) => {
  const url = `${API_URL}wallet/getWallet`;

  try {
    const response = await fetch(url, {
      method: "POST", // Use POST method as per your request details
      headers: {
        "Content-Type": "application/json", // Specify content type
        Authorization: `Bearer ${token}`, // Include the Bearer token
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch wallet details");
    }

    const data = await response.json();
    console.log(data.data);
    return data.data;
  } catch (error) {
    console.error("Error fetching wallet details:", error.message);
    throw error;
  }
};

export const addCard = async (token) => {
  const response = await fetch(`${API_URL}wallet/addCard`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return response.json();
};

export const updateWallet = async (walletData) => {
  const response = await fetch(`${API_URL}/wallet/updateWallet`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(walletData),
  });
  return response.json();
};

export const deleteCard = async (token) => {
  const response = await fetch(`${API_URL}wallet/deleteCard`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Include the Bearer token
    },
  });
  return response.json();
};

export const getWalletDetails = async (token) => {
  const response = await fetch(
    `${API_URL}/wallet/getWalletDetails?token=${encodeURIComponent(token)}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  return response.json();
};
